module.exports = __webpack_public_path__ + "static/pi6-8da1a1205caee85bb31cf6abde12aeff.png";